<template>
  <div class="center">
    <!-- 头部 -->
    <header>
     <img src="../../../assets/img/bg2.png" alt="">
      <div class="flex aic users pixed">
        <router-link v-if="!isLogin" to="/login" class="f16 fff ml-5">立即登录</router-link>
        <span v-else class="f16 ml-5 fff">{{phone}}</span>
      </div>
    </header>

    <!-- 主体 -->
    <main class="mt-5">
      <div class="bg-fff">
        <van-cell title="我的订单" isLink to="/order/list"></van-cell>
        <van-cell title="收藏" isLink to="/favorite"></van-cell>
        <van-cell title="足迹" isLink to="/footprint"></van-cell>
        <van-cell title="优惠券" isLink></van-cell>
        <van-cell title="我的地址" isLink></van-cell>
        <van-cell title="设置" isLink to="/my/set"></van-cell>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import { mapGetters } from "vuex";
export default {
  components: {
    Footer
  },

  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    phone() {
      let phone = this.$store.state.phone;
      return phone.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
    }
  }
};
</script>

<style lang="less" scoped>
@import "./center.less";
</style>